export default {
  s: '%d san',
  smicro: '%d s',
  smid: '%d san',

  ss: '%d san',
  ssmicro: '%d s',
  ssmid: '%d san',

  m: '%d dəq',
  mmicro: '%d d',
  mmid: '%d dəq',

  mm: '%d dəq',
  mmmicro: '%d dəq',
  mmmid: '%d dəq',

  h: '%d s',
  hmicro: '%d s',
  hmid: '%d s',

  hh: '%d s',
  hhmicro: '%d s',
  hhmid: '%d s',

  d: '%d gün',
  dmicro: '%d g',
  dmid: '%d gün',

  dd: '%d günlər',
  ddmicro: '%d g',
  ddmid: '%d günlər',
};
